import type { ProductCarouselVariant } from '../components/ProductCarousel';

export const productCarouselConfig = (isInDrawer: boolean, variant: ProductCarouselVariant, productNumber: number) => {
    const defaultGap = isInDrawer ? 8 : 32;

    const getCarouselTilesPerView = (): number => {
        if (isInDrawer) {
            return 3;
        }

        const tileToVariantMap: Record<ProductCarouselVariant, number> = {
            storytelling: 4,
            campaign: 5,
            default: 6,
        };

        return tileToVariantMap[variant] || 6;
    };

    const disableArrows = isInDrawer
        ? productNumber <= 3
        : variant === 'storytelling'
          ? productNumber <= 4
          : productNumber <= 6;

    const breakpoints = {
        1200: {
            perView: isInDrawer ? 3 : 4,
            gap: isInDrawer ? 8 : 24,
        },
        560: {
            perView: isInDrawer ? 3 : 2.5,
            gap: 8,
        },
    };

    return {
        disableArrows,
        defaultGap,
        perViewDefault: getCarouselTilesPerView(),
        breakpoints,
    };
};
